








































































import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { calendarService } from '../../../shared/services/api/calendar.service';
import EventDetails from './event_details/EventDetails.vue';
import CalendarEventFooterAdministerButtons from '../../../shared/PageFragments/CalendarEvent/CalendarEventFooterAdministerButtons.vue';
import { mapGetters, mapActions } from 'vuex';
import { types } from '../../store/types/types.js';
import CalendarEventFooterResponseButtons from '../../../shared/PageFragments/CalendarEvent/CalendarEventFooterResponseButtons.vue';
import { eventResponseStatus } from '../../../shared/enums/eventResponseStatus';
import EventDetailsSeatSelection from './event_details/EventDetailsSeatSelection.vue';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';
import { permissionEnum } from '../../../shared/enums/permissionEnum';
import { PropType, VNode } from 'vue';
import EventDetailsTimeslots from './event_details/EventDetailsTimeslots.vue';
import { parentTypes } from '../../../shared/enums/parentTypes';
import { EventData } from '../../business/calendar/eventData';
import { CalendarEventModel } from '../../../shared/models/calendarEvent.model';
import { eventTypeEnum } from '../../../shared/enums/eventTypeEnum';
import Icon from '../../../shared/components/Icon.vue';
import { portalRoles } from '../../../shared/enums/portalRoles';
import { useUserProfileStore } from '../../../shared/stores';

export default {
  name: 'CalendarEventModal',
  components: {
    Icon,
    EventDetailsTimeslots,
    EventDetailsSeatSelection,
    CalendarEventFooterResponseButtons,
    CalendarEventFooterAdministerButtons,
    EventDetails,
  },
  props: {
    parent: { type: String as PropType<parentTypes>, default: parentTypes.PROFILE },
    showSeriesResponses: { type: Boolean, default: true },
    showOccurrenceResponses: { type: Boolean, default: true },
  },
  emits: ['deleted', 'responded', 'openAttachment'],
  data() {
    return {
      isVisible: false,
      title: '',
      eventData: null as EventData,
      selectedDate: null,
      regardingInstitutionProfileIds: [] as number[],
      isLoading: false,
      numberOfAdults: null,
      numberOfChildren: null,
      hasSeatsChanged: false,
      isMissingSeatSelections: false,
    };
  },
  computed: {
    eventResponseStatus() {
      return eventResponseStatus;
    },
    ...mapGetters({
      institutions: types.GET_INSTITUTIONS,
      activeInstitutionCodes: types.GET_ACTIVE_INSTITUTIONS,
      activeGroupHome: types.GET_ACTIVE_GROUP_HOME,
      activeOtpInboxes: types.MESSAGES_GET_OTP_INBOXES,
      delegatedContext: types.GET_DELEGATED_CONTEXT,
      hasPermissionOnInstitution: types.HAS_PERMISSION_ON_INSTITUTION,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
    activeInstitutionProfileIds() {
      return this.institutions
        .filter(institution => this.activeInstitutionCodes.includes(institution.institutionCode))
        .map(institution => institution.institutionProfileId);
    },
    canViewTimeslots() {
      return (
        this.eventData?.hasTimeslots &&
        (this.profile.role === portalRoles.EMPLOYEE || this.canOrganize || this.canRespond)
      );
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    canSeeResponseButtons() {
      return this.canRespond && !this.eventData?.hasTimeslots;
    },
    isHandlingOthersEvent() {
      const hasPermission = this.hasPermissionOnInstitution(
        permissionEnum.HANDLE_OTHERS_EVENTS,
        this.eventData?.institutionCode
      );
      return hasPermission && !this.eventData?.isCreator && !this.eventData?.isCoOrganizer;
    },
    canHandleLesson() {
      return this.profile.role === portalRoles.EMPLOYEE && this.eventData?.isLesson;
    },
    canEdit() {
      return this.canOrganize || this.isHandlingOthersEvent || this.canHandleLesson;
    },
    canOrganize() {
      return this.eventData?.canOrganize === true;
    },
    canRespond() {
      return this.eventData?.canRespond === true;
    },
    hasFooter() {
      if (this.isLoading) {
        return false;
      }
      return this.canSeeResponseButtons || this.canViewTimeslots;
    },
    occupiedSeats() {
      let adjustedSeats = this.numberOfAdults + this.numberOfChildren;
      if (this.eventData.response?.responseType === eventResponseStatus.ACCEPTED) {
        adjustedSeats =
          adjustedSeats -
          this.eventData.response.numberOfAdultParticipants -
          this.eventData.response.numberOfChildParticipants;
      }
      return this.eventData.actualNumberOfParticipants + adjustedSeats;
    },
    isOverCapacity() {
      return this.occupiedSeats > this.eventData.seats;
    },
    remainingSeats() {
      let remainingSeats = this.eventData.seats - this.eventData.actualNumberOfParticipants;
      if (this.eventData.response?.responseType === eventResponseStatus.ACCEPTED) {
        remainingSeats =
          remainingSeats +
          this.eventData.response.numberOfAdultParticipants +
          this.eventData.response.numberOfChildParticipants;
      }
      return remainingSeats;
    },
    isFull() {
      return this.remainingSeats <= 0;
    },
  },
  methods: {
    ...mapActions({
      loadOtpInboxes: types.ACTION_GET_OTP_INBOXES,
    }),
    async show(eventData: CalendarEventModel, selectedDate = null, regardingInstitutionProfileIds: number[] = []) {
      this.isVisible = true;
      this.selectedDate = selectedDate;
      this.regardingInstitutionProfileIds = regardingInstitutionProfileIds;
      await this.populateEventData(eventData);
    },
    hide() {
      this.isVisible = false;
    },
    reset() {
      this.eventData = null;
      this.hasSeatsChanged = false;
      this.numberOfAdults = null;
      this.numberOfChildren = null;
      this.isMissingSeatSelections = false;
    },
    async populateEventData(eventData) {
      this.title = eventData.title;
      this.isLoading = true;

      if (eventData.extendedProps?.type === eventTypeEnum.BIRTHDAY) {
        this.mapBirthdayEvent(eventData);
      } else {
        await this.getEventDetails(eventData.id);
      }

      this.isLoading = false;
      this.initialize();
    },
    mapBirthdayEvent(eventData) {
      this.eventData = new EventData(
        {
          id: null,
          title: eventData.title,
          allDay: eventData.allDay,
          startDateTime: DateTimeUtil.formatDate(DateTimeUtil.getStartOf(eventData.start, 'day'), ''),
          endDateTime: DateTimeUtil.formatDate(DateTimeUtil.getEndOf(eventData.start, 'day'), ''),
          oldStartDateTime: '',
          oldEndDateTime: '',
          responseRequired: false,
          private: false,
          type: eventTypeEnum.BIRTHDAY,
          addedToInstitutionCalendar: false,
          isDeleted: false,
          eventClass: '',
          isDeadlineExceeded: false,
          hideInOwnCalendar: false,
          doRequestNumberOfParticipants: false,
          creator: null,
          description: null,
          pendingMedia: false,
          attachments: [],
          additionalResources: [],
        },
        this.regardingInstitutionProfileIds,
        [eventData.extendedProps.institutionProfileId]
      );
    },
    initialize() {
      if (this.eventData.isInvitee) {
        this.numberOfAdults = this.eventData.response?.numberOfAdultParticipants || null;
        this.numberOfChildren = this.eventData.response?.numberOfChildParticipants || null;
      }
    },
    getEventRelatedInstitutionProfileId() {
      if (this.delegatedContext?.institutionProfileId) {
        return [this.delegatedContext.institutionProfileId];
      }
      return this.activeInstitutionProfileIds;
    },
    handleAdultSeatsChange(value: number) {
      this.numberOfAdults = value;
      this.hasSeatsChanged = true;
      this.checkValidSeats();
    },
    handleChildSeatsChange(value: number) {
      this.numberOfChildren = value;
      this.hasSeatsChanged = true;
      this.checkValidSeats();
    },
    checkValidSeats() {
      const numberOfAdults = this.numberOfAdults || 0;
      const numberOfChildren = this.numberOfChildren || 0;
      this.isMissingSeatSelections = this.eventData.isRequiredSeatSelection && numberOfAdults + numberOfChildren === 0;
      return !this.isOverCapacity && !this.isMissingSeatSelections;
    },
    async getEventDetails(eventId: number) {
      try {
        const eventData = await calendarService.getEventById(eventId, this.selectedDate);
        const institutionProfileIds = this.getEventRelatedInstitutionProfileId(eventData);
        const groupHomeId = this.activeGroupHome?.id || null;
        this.title = eventData.title;
        const regardingChildrenFromGroupHomeIds = (this.activeGroupHome?.children || []).map(child => child.id);
        const activeOtpInboxIds = this.activeOtpInboxes.map(otpInbox => otpInbox.id);

        this.eventData = new EventData(
          eventData,
          this.regardingInstitutionProfileIds,
          institutionProfileIds,
          groupHomeId,
          this.selectedDate,
          regardingChildrenFromGroupHomeIds,
          activeOtpInboxIds
        );
      } catch (err) {
        this.$showToast(this.$t('error.api_error_event').toString(), 'error');
      }
    },
    getDeletionWarningNodes(isCurrentEvent: boolean = false): VNode[] {
      const deletingEventWarningKeys = ['warning.deleting_event'];
      const deletingOthersEventWarningKeys = ['warning.deleting_others_event_1', 'warning.deleting_others_event_2'];
      const deletingEventOccurrenceWarningKeys = ['warning.deleting_occurrence_1', 'warning.deleting_occurrence_2'];
      const deletingEventSeriesWarningKeys = ['warning.deleting_series_1', 'warning.deleting_series_2'];
      let selectedKeys: string[] = [];

      if (this.isHandlingOthersEvent) {
        selectedKeys = deletingOthersEventWarningKeys;
      } else if (this.eventData.isRepeating) {
        selectedKeys = isCurrentEvent ? deletingEventOccurrenceWarningKeys : deletingEventSeriesWarningKeys;
      } else {
        selectedKeys = deletingEventWarningKeys;
      }
      return selectedKeys.map(key => this.$createElement('p', this.$t(key)));
    },
    async deleteEvent(isCurrentEvent: boolean = false) {
      let occurrenceDateTime: string;
      if (isCurrentEvent) {
        occurrenceDateTime = DateTimeUtil.formatDate(this.eventData.startDateTime, 'YYYY-MM-DD');
      }
      await calendarService.deleteEvent({ id: this.eventData.id, occurrenceDateTime });
    },
    handleDeleteEventClick(isCurrentEvent: boolean = false) {
      const warningNodes = this.getDeletionWarningNodes(isCurrentEvent);
      this.$confirmAction(warningNodes).then(isConfirmed => {
        if (isConfirmed === true) {
          this.deleteEvent(isCurrentEvent);
          this.hide();
          this.$emit('deleted');
        }
      });
    },
    handleEditEventClick(isCurrentEvent: boolean = false) {
      let occurrenceDateTime: string;
      let routeName: string;
      if (isCurrentEvent) {
        occurrenceDateTime = DateTimeUtil.formatDate(this.eventData.startDateTime, 'YYYY-MM-DD');
      }
      if (this.eventData.hasTimeslots) {
        routeName = this.parent === parentTypes.GROUP ? 'group-calendar-edit-meeting-event' : 'editMeetingEvent';
      } else {
        routeName = this.parent === parentTypes.GROUP ? 'group-calendar-edit-event' : 'editEvent';
      }
      const query = { occurrence: occurrenceDateTime, parent: this.parent };
      const params = { eventId: this.eventData.id };
      this.$router.push({ name: routeName, params, query });
      this.hide();
    },
    handleTimeslotResponded() {
      this.hide();
      this.$emit('responded');
    },
    async handleRespondClick(responseType: eventResponseStatus, isCurrentEvent: boolean = false) {
      if (responseType === eventResponseStatus.ACCEPTED && !this.checkValidSeats()) {
        return;
      }
      let occurrenceDateTime: string;
      if (isCurrentEvent) {
        occurrenceDateTime = DateTimeUtil.formatDate(this.eventData.startDateTime, 'YYYY-MM-DD');
      }
      await this.respond(responseType, occurrenceDateTime);
      this.showResponseMessage(responseType);
      this.hide();
      this.$emit('responded');
    },
    async respond(responseType: eventResponseStatus, occurrenceDateTime: string = null) {
      await calendarService.respondToSimpleEvent({
        eventId: this.eventData.id,
        responseType,
        occurrenceDateTime,
        numberOfAdultParticipants: this.numberOfAdults,
        numberOfChildParticipants: this.numberOfChildren,
        activeGroupHomeId: this.activeGroupHome?.id ?? null,
      });
    },
    showResponseMessage(responseType: eventResponseStatus) {
      const message = this.eventData.getResponseToastMessage(responseType);
      this.$showToast(message);
    },
    emitOpenAttachment(data) {
      this.$emit('openAttachment', data);
    },
  },
  async mounted() {
    if (this.profile.role === portalRoles.OTP) {
      await this.loadOtpInboxes();
    }
  },
};
